import React from 'react';
import { Route, Switch } from 'react-router-dom';
import Users from '../../../UsersList/index';

export default () => (
  <Switch>
    <Route exact path="/users" component={Users} />
  </Switch>
);
